import * as React from 'react';

import { jFileLittle } from 'jamespot-user-api';

import { JRCButton } from 'components/JRCButton/JRCButton';
import { useIntl } from 'react-intl';

import {
    CSSActionAccessor,
    CSSOpacityFilter,
    CSSTitle,
    CSSTitleAccessor,
    CSSDocument,
    CSSDocumentTitle,
    CSSDocumentOption,
} from '../styles';

import { JRCFileAvatar } from 'components/JRCFile/JRCFileAvatar';
import { inUriArray, updateUriArray } from '../utils';

export type FileLittleListProps = {
    files: jFileLittle[];
    initialUris: string[];
    allowMultiSelection?: boolean;
    onSelectFile?: (uri: string[]) => void;
};

export const FileLittleList = ({ files, initialUris, allowMultiSelection, onSelectFile }: FileLittleListProps) => {
    const intl = useIntl();
    const [uris, setUris] = React.useState<string[]>(initialUris);

    const selectFile = React.useCallback(
        (uris: string[]) => {
            setUris(uris);
            if (onSelectFile) {
                onSelectFile(uris);
            }
        },
        [onSelectFile],
    );
    return (
        <>
            {files.map((file) => {
                return (
                    <CSSDocument key={file.uri}>
                        <CSSDocumentTitle>
                            <CSSOpacityFilter opacity={inUriArray(uris, file.uri) ? 0.4 : 1}>
                                <CSSTitleAccessor>
                                    <JRCFileAvatar uri={undefined} size={40} mimetype={file.mimetype} />
                                    <CSSTitle>{file.title}</CSSTitle>
                                </CSSTitleAccessor>
                            </CSSOpacityFilter>
                        </CSSDocumentTitle>
                        <CSSDocumentOption>
                            {onSelectFile ? (
                                <CSSActionAccessor>
                                    <JRCButton
                                        onClick={() =>
                                            allowMultiSelection
                                                ? selectFile(updateUriArray(uris, file.uri))
                                                : selectFile([file.uri])
                                        }
                                        type="button"
                                        color="primary"
                                        variant={inUriArray(uris, file.uri) ? 'contained' : 'outlined'}>
                                        {intl.formatMessage({ id: 'GLOBAL_Select' })}
                                    </JRCButton>
                                </CSSActionAccessor>
                            ) : (
                                <></>
                            )}
                        </CSSDocumentOption>
                    </CSSDocument>
                );
            })}
        </>
    );
};
